export default __webpack_public_path__ + "static/media/idea-card-02.c48db4e9.jpg";